import { IUser, IUserUnreadMessages } from '../../api/user'
import { authTokenPath, refreshTokenPath } from '../../constants/Config'

export interface IUserState {
  isLoading: boolean
  user: IUser
  userUnreadMessages: IUserUnreadMessages
  token?: string
  refreshToken?: string
  error?: string
}

export const initialUserState: IUserState = {
  user: {
    Id: '',
    Name: '',
    Email: '',
    Phone: '',
    PreferredTags: [],
    PreferredLanguage: 'default',
    IsSnooze: false,
    SnoozeTime: '',
    BookmarkedNews: [],
    BookmarkedAnalyses: [],
    DidUnsubscribe: false,
  },
  userUnreadMessages: {
    unreadArticlesCount: 0,
    unreadAnalysesCount: 0,
    unreadArticles: [],
    unreadAnalyses: [],
  },
  isLoading: false,
  token: localStorage.getItem(authTokenPath) || '',
  refreshToken: localStorage.getItem(refreshTokenPath) || '',
}
